import React from 'react';
import { useSelector } from 'react-redux';
import ToolTipModal from '../../../components/Modals/ToolTip Modal';
import MobileFilterModal from '../mobileFilterModal';

/** @type {React.FC<import("../../../typings").IHomepageModalProps>} */
const HomePageModal = ({ pageState, setPageState }) => {
  /** @type {import('../../../typings').IStateReducerState}*/
  const { isMobile } = useSelector((state) => state.appReducer);

  const handleMobileClose = () => {
    setPageState((prev) => ({
      ...prev,
      showMobileFilterModal: false,
    }));
  };
  const removeSpreadFunction = () => {
    setPageState({
      ...pageState,
      toggleNoSpreads: !pageState.toggleNoSpreads,
    });
  };
  const removeWeeksFunction = () => {
    setPageState({
      ...pageState,
      toggleRemoveWeeks: !pageState.toggleRemoveWeeks,
    });
  };
  const onlyAtmFunction = () => {
    setPageState({
      ...pageState,
      toggleOnlyAtm: !pageState.toggleOnlyAtm,
    });
  };
  const removeWeeksTable2Function = () => {
    setPageState({
      ...pageState,
      toggleRemoveWeeksTable2: !pageState.toggleRemoveWeeksTable2,
    });
  };
  return (
    <div>
      {pageState.showModal && (
        <ToolTipModal
          showModal={pageState.showModal}
          clickHandler={() =>
            setPageState({
              ...pageState,
              showModal: false,
            })
          }
          onCloseHandler={() => {
            setPageState({
              ...pageState,
              showModal: false,
            });
          }}
          isMobile={isMobile}
          type={pageState.currentType}
        />
      )}
      {pageState.showMobileFilterModal && (
        <MobileFilterModal
          filterType={pageState.currentFilterType}
          showModal={pageState.showMobileFilterModal}
          handleMobileClose={handleMobileClose}
          onlyAtm={pageState.toggleOnlyAtm}
          removeWeeks={pageState.toggleRemoveWeeks}
          noSpreads={pageState.toggleNoSpreads}
          onlyAtmFunction={onlyAtmFunction}
          removeSpreadFunction={removeSpreadFunction}
          removeWeeksFunction={removeWeeksFunction}
          removeWeeksTable2Function={removeWeeksTable2Function}
          removeWeeksTable2={pageState.toggleRemoveWeeksTable2}
        />
      )}
    </div>
  );
};

export default HomePageModal;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/Modal/index.jsx